import { render, staticRenderFns } from "./Post.vue?vue&type=template&id=bb9fa01c&scoped=true&"
import script from "./Post.vue?vue&type=script&lang=js&"
export * from "./Post.vue?vue&type=script&lang=js&"
import style0 from "./Post.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Post.vue?vue&type=style&index=1&id=bb9fa01c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb9fa01c",
  null
  
)

export default component.exports